import { render, staticRenderFns } from "./file-confirm-modal.vue?vue&type=template&id=4e696c2d&scoped=true"
import script from "./file-confirm-modal.vue?vue&type=script&lang=js"
export * from "./file-confirm-modal.vue?vue&type=script&lang=js"
import style0 from "./file-confirm-modal.vue?vue&type=style&index=0&id=4e696c2d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e696c2d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e696c2d')) {
      api.createRecord('4e696c2d', component.options)
    } else {
      api.reload('4e696c2d', component.options)
    }
    module.hot.accept("./file-confirm-modal.vue?vue&type=template&id=4e696c2d&scoped=true", function () {
      api.rerender('4e696c2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/pbc-management/file-confirm-modal.vue"
export default component.exports